export type School = {
  "@context": string;
  "@id": string;
  "@type": string;
  id: number;
  name: string;
  abbreviation?: string | null;
  minimumSelectionPolicy: "TWO_REQUIRED" | "SINGLE_ALLOWED";
};
